import { DeviceLite } from "../device/device.model";
import {
  Point,
  PointGroupLite,
  PointResponse,
  PointType,
  PointValue,
  PointWithValue,
  PuckValue,
} from "../point/point.model";

export class AlarmValue extends PointValue {
  alarmState: number | null;
  alarmGroup?: string | null;
  isActive?: boolean;
  isAcknowledged?: boolean | null;

  constructor(value: PuckValue) {
    super(value);
    this.alarmState = value.alarmState;
    this.alarmGroup = value.alarmGroup;
    this.isAcknowledged =
      value && value.alarmState != undefined
        ? value.alarmState !== 0
        : undefined;
    this.isActive = value && value !== null ? value.value === 1 : undefined;
  }
}

export abstract class AlarmBase extends PointWithValue {
  value?: AlarmValue;

  constructor(alarm: PointResponse) {
    super(alarm);

    this.value =
      alarm.value && Object.keys(alarm.value).length > 0
        ? new AlarmValue(alarm.value)
        : undefined;
  }
}
export type AlarmResponse = PointResponse & { alarmGroup: string | null };

export class Alarm extends AlarmBase implements Point {
  device: DeviceLite;
  buildingName: string | null;
  type: PointType;
  unit: string | null;
  graphicLink?: string | null;
  stateTexts?: { label: string; value: number }[];
  alarmGroup: string | null;
  decimals: number | null;
  pointGroups: PointGroupLite[];

  constructor(alarm: AlarmResponse) {
    super(alarm);
    this.device = alarm.device;
    this.buildingName = alarm.buildingName;
    this.type = PointType.Alarm;
    this.graphicLink = alarm.graphicLink;
    this.unit = alarm.unit;
    this.stateTexts = alarm.stateTexts;
    this.alarmGroup = alarm.alarmGroup;
    this.decimals = alarm.decimals;
    this.pointGroups = alarm.pointGroups;
  }
}

export class AlarmList extends AlarmBase {
  device: Pick<DeviceLite, "id" | "name" | "type">;
  buildingName: string | null;

  constructor(alarm: AlarmResponse) {
    super(alarm);
    this.device = alarm.device;
    this.buildingName = alarm.buildingName;
  }
}
